// @core/api/endpoints/team/update_team_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamUISettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team UI settings
 * Updates an existing team u i settings with the provided data. Returns the updated resource.
 */
export async function UpdateTeamUISettings(
  team_id: string,
  data: UpdateTeamUISettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/ui`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
